// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2XTgv","logo":"styles_logo__22loG","textWrapper":"styles_textWrapper__1aUho"};